export default {
  'Resize for': 'Изменить размер для',
  'Add 10 videos at most': 'Добавить не более 10 видео.',
}